import React, { useEffect } from 'react'
import {
    Container,
    BotListContainer,
    NewButtonContainer,
    VerticallyCenterContainer,
    BannerContainer
} from './Styled'
import Item from './item/Item'
import HomeLayout from '../layouts/homeLayout/HomeLayout'
import { Button } from 'antd'
import EmptyBanner from './emptyBanner/EmptyBanner'
import { RootState } from '../../model/rootReducer'
import { useSelector } from 'react-redux'
import NewBotButton from './newBotButton/NewBotButton';

type BotListProps = {}

export const BotList: React.FunctionComponent<BotListProps> = props => {

    const bots = useSelector((state: RootState) => state.bot.bots)

    const Empty = () => (
        <BannerContainer>
            <EmptyBanner />
        </BannerContainer>
    )

    const BotResult = () => (
        <>
            <NewButtonContainer>
                <NewBotButton/>
            </NewButtonContainer>
            <BotListContainer>
                {bots.map((item) => (
                    <Item {...item} />
                ))}
            </BotListContainer>
        </>
    )
    return (
        <HomeLayout
            title="Agents conversationnels"
            subTitle="Créer ou configurez vos agents conversationnels"
            onBackDestination="/"
        >
            <Container>
                <VerticallyCenterContainer>
                    {bots.length > 0 ? <BotResult /> : <Empty />}
                </VerticallyCenterContainer>
            </Container>
        </HomeLayout>
    )
}

export default BotList
